import isMatch from 'lodash/isMatch';

import { DeviceOfferDetail, DeviceOfferDetails } from '../typings';

type FeatureMatcher = {
  -readonly [str in keyof DeviceOfferDetail]?: string;
};

export function getSelectedDevice(
  offers: DeviceOfferDetails,
  selectedColor: string,
  selectedStorage: string,
) {
  const featureMatcher: FeatureMatcher = {};

  if (selectedColor) {
    featureMatcher.colorHex = selectedColor;
  }
  if (selectedStorage) {
    featureMatcher.storage = selectedStorage;
  }

  return offers.find((offer) => isMatch(offer, featureMatcher)) || offers[0];
}

export function getDeviceOfferId(offerIdQueryParam?: string | string[]) {
  return Array.isArray(offerIdQueryParam)
    ? offerIdQueryParam[0]
    : offerIdQueryParam;
}

export function getSelectedDeviceById(
  offers: DeviceOfferDetails,
  offerId?: string,
) {
  const selectedDevice = offerId && offers.find(({ id }) => id === offerId);

  if (!selectedDevice) {
    return offers.find(({ isDefault }) => isDefault) || offers[0];
  }

  return selectedDevice;
}

/**
 * Returns the selected device based on offerId query param or isDefault flag
 */
export function getInitialDeviceState(
  offers: DeviceOfferDetails,
  offerId?: string,
) {
  if (!offers) return null;

  const selectedDevice = getSelectedDeviceById(offers, offerId);

  return {
    deviceOffers: offers,
    selectedDeviceId: selectedDevice.id,
    selectedDevice,
  };
}
